import Image from 'next/image';

import { NOPING_GREEN } from '../constants';

const GAMES = [
  { name: 'Valorant', src: '/images/Valorant.webp' },
  { name: 'CS2', src: '/images/CS2.webp' },
  { name: 'Fortnite', src: '/images/Fortnite.webp' },
  { name: 'Dota 2', src: '/images/Dota2.webp' },
  { name: 'World of Warcraft', src: '/images/World of Warcraft.webp' },
  { name: 'Final Fantasy XIV', src: '/images/Final Fantasy XIV.webp' },
  { name: 'Ragnarok', src: '/images/Ragnarok.webp' },
  { name: 'StarCraft', src: '/images/StarCraft.webp' },
];

function GameCard({ name, src }: { name: string; src: string }) {
  return (
    <div className='mx-4 w-[180px] shrink-0'>
      <div className='flex flex-col items-center gap-3 overflow-hidden rounded-2xl border bg-[#0D0D12] p-4 transition-all duration-300 hover:scale-105 hover:border-[#93FF18]/40' style={{ borderColor: `${NOPING_GREEN}20` }}>
        <div className='relative h-[200px] w-[150px] overflow-hidden rounded-xl'>
          <Image src={src} alt={name} fill className='object-cover' sizes='150px' />
        </div>
        <span className='w-full truncate text-center text-sm font-semibold text-white/90' style={{ fontFamily: 'var(--font-outfit)' }}>
          {name}
        </span>
      </div>
    </div>
  );
}

export function GameCarousel() {
  const items = [...GAMES, ...GAMES];

  return (
    <div className='relative w-full overflow-hidden py-4' style={{ maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)', WebkitMaskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)' }}>
      <div className='pt-game-track flex items-center'>
        {items.map((game, i) => (
          <GameCard key={`${game.name}-${i}`} name={game.name} src={game.src} />
        ))}
      </div>
      {/* `transform` is physical, so CSS never mirrors it for writing direction. This track is
          `width: max-content` inside a narrower clip box, so under the `dir="rtl"` that /sa inherits
          from <html> the over-constrained box anchors to the RIGHT edge and overflows left — and the
          negative shift then drags the strip out of the clip box instead of through it, draining it to
          empty partway through the loop. The mirrored keyframes shift positive; only `animation-name`
          is overridden, so duration and timing stay in one place. Same call as the home genre marquee. */}
      <style dangerouslySetInnerHTML={{ __html: '.pt-game-track { animation: pt-scroll-games 45s linear infinite; width: max-content; } .pt-game-track:hover { animation-play-state: paused; } @keyframes pt-scroll-games { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } } @keyframes pt-scroll-games-rtl { 0% { transform: translateX(0); } 100% { transform: translateX(50%); } } [dir="rtl"] .pt-game-track { animation-name: pt-scroll-games-rtl; }' }} />
    </div>
  );
}
